import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import { Scenes } from "../pages/scenes/Scenes";
import { useEffect } from "react";
import isDevMode from "../util/isDevMode";

export default function NavigationRoutes() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirige al montar el componente
    if (!isDevMode()) navigate("/scenes");
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/scenes" replace />} />
      <Route path="/scenes" element={<Scenes />} />
      <Route path="/scenes/:sceneId" element={<Scenes />} />
    </Routes>
  );
}
